s<template>
    <section class="o-page-bottom-spacing">
        <page-header>
            <slot slot="title">{{ $t('size_chart.page_header_edit') }}</slot>
        </page-header>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">

                <div class="u-max-1000 c-form-row">
                    <v-loading :data="loaded" type="global"></v-loading>

                    <div>
                        <div class="u-margin-bottom">
                            <v-form-row>
                                <v-custom-select v-model="SizeChart.Brand"
                                                 v-if="SizeChart.Brand"
                                                :options="BrandsOptions"
                                                 option-name="Name"
                                                 option-value="Code"
                                                 :error="Validate.Brand"
                                                 name="brand"
                                                 search-label="Name"
                                                 track-by="Code"
                                                 :fluid="true"
                                                 :multiple="false">
                                    <slot slot="label">{{ $t('size_chart.label.brand') }}</slot>
                                </v-custom-select>
                            </v-form-row>
                        </div>
                        <div class="u-margin-bottom">
                          <v-form-row>
                            <v-input v-model="SizeChart.Name" name="size_chart_name" :fluid="true" :error="Validate.Name">
                              <slot slot="label">{{ $t('size_chart.label.name') }}</slot>
                            </v-input>
                          </v-form-row>
                        </div>
                    </div>
                    <div class="o-grid o-grid--half u-margin-bottom-large">
                        <div>
                            <v-form-row>
                              <v-input v-model.number="SizeChart.Columns" name="columns" type="number" :min=1 :max="5" :error="Validate.Columns">
                                <slot slot="label">{{ $t('size_chart.label.columns') }}</slot>
                              </v-input>
                            </v-form-row>
                        </div>
                        <div>
                            <v-form-row>
                              <v-input v-model.number="SizeChart.Rows" name="rows" type="number" :min=1 :error="Validate.Rows">
                                <slot slot="label">{{ $t('size_chart.label.rows') }}</slot>
                              </v-input>
                            </v-form-row>
                        </div>
                    </div>


                    <div class="u-margin-bottom-large" style="overflow: hidden">
                      <v-size-chart :cells="SizeChart.Cells"
                                    :rows="SizeChart.Rows"
                                    :columns="SizeChart.Columns">
                      </v-size-chart>
                    </div>


                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <button @click="submitForm" class="c-button c-button--alpha">{{ $t('size_chart.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import VLoading from '@/components/Loading'
    import PageHeader from '@/components/common/PageHeader'
    import VSizeChart from '@/components/sizeChart/SizeChart'

    // Forms
    import VTextarea from '@/components/form/Textarea'
    import VPictureInput from '@/components/form/PictureInput'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import VDatepicker from '@/components/form/Datepicker'
    import VTargetListSelect from '@/components/form/targetList/TargetListSelect'
    import VSwitch from '@/components/form/Switch'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VLoading,
            PageHeader,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow,
            VDatepicker,
            VTargetListSelect,
            VSwitch,
            VPictureInput,
            VSizeChart
        },
        data() {
            return {
                Validate: {},
                loaded: {}
            }
        },
        computed: {
            ...mapGetters({
                BrandsOptions: 'BrandsOptions',
                SizeChart: 'SizeChart'
            }),
        },
        created: function () {
            this.$store.dispatch('getBrandsOptions');
            this.$store.dispatch('getSizeChart', this.$attrs.id).then(() => {
                this.loaded = { isLoaded: true }
            });
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;

                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });

                this.Validate = errors;
            },
            submitForm(e) {
                this.loaded = {}
                this.$store.dispatch('updateSizeChart', this.SizeChart).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                    } else {
                        this.$router.push({
                            name: 'SizeChartOverview'
                        });
                    }
                    this.loaded = { isLoaded: true }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
                e.preventDefault();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/admin/sizeCharts/Edit.vue